import BoolInput from './questions/Bool/components/BoolInput';
import BoolValue from './questions/Bool/components/BoolValue';
import BoolImage from '../../../assets/img/prompt-yes-no-dialog.svg';
import DocumentsInput from './questions/Documents/components/DocumentsInput';
import DocumentsValue from './questions/Documents/components/DocumentsValue';
import DocumentsImage from '../../../assets/img/prompt-upload-dialog.svg';
import TextInput from './questions/Text/components/TextInput';
import TextValue from './questions/Text/components/TextValue';
import TextImage from '../../../assets/img/prompt-text-dialog.svg';
import UnknownInput from './questions/Unknown/components/UnknownInput';
import UnknownValue from './questions/Unknown/components/UnknownValue';
var questionComponentRegistry = {
  BOOL: {
    ValueComponent: BoolValue,
    InputComponent: BoolInput,
    image: BoolImage
  },
  DOCUMENTS: {
    ValueComponent: DocumentsValue,
    InputComponent: DocumentsInput,
    image: DocumentsImage
  },
  TEXT: {
    ValueComponent: TextValue,
    InputComponent: TextInput,
    image: TextImage
  }
};
var unknownEntry = {
  ValueComponent: UnknownValue,
  InputComponent: UnknownInput
};
export function getQuestionComponentRegistryEntry(type) {
  return questionComponentRegistry[type] || unknownEntry;
}
//# sourceMappingURL=component-registry.js.map
